import React from 'react';
import Skeleton from './Skeleton';

export interface DivTableColumn {
  label?: string;
  width?: string | number;
  height?: number;
}

interface DivTableSkeletonProps {
  rows?: number;
  columns: DivTableColumn[];
  rowClassName?: string;
  cellClassName?: string;
  labelClassName?: string;
}

const DivTableSkeleton: React.FC<DivTableSkeletonProps> = ({
  rows = 5,
  columns,
  rowClassName = '',
  cellClassName = '',
  labelClassName = '',
}) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={`div-table-skeleton-row-${rowIndex}`} className={rowClassName}>
          {columns.map((col, colIndex) => (
            <div key={`div-table-skeleton-col-${colIndex}`} className={cellClassName}>
              {col.label && <span className={labelClassName}>{col.label}</span>}
              <Skeleton animation="pulse" width={col.width || '100%'} height={col.height || 20} />
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default DivTableSkeleton;
